import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AddPriceGroupInput } from "~/gql/graphqlBase.generated";
import { PriceGroupMetaDataFragment } from "~/gql/queries/price.generated";

interface PriceState {
	addPriceGroupInput?: AddPriceGroupInput;
	priceGroup?: PriceGroupMetaDataFragment;
}

const initialState: PriceState = {};

export const productSlice = createSlice({
	initialState,
	name: "price",
	reducers: {
		setAddPriceGroupInput: (state, action: PayloadAction<AddPriceGroupInput | null>) => {
			if (action.payload === null) {
				state.addPriceGroupInput = undefined;
				return;
			}
			state.addPriceGroupInput = { ...action.payload };
		},
		setPriceGroup: (state, action: PayloadAction<PriceGroupMetaDataFragment | null>) => {
			if (action.payload === null) {
				state.priceGroup = undefined;
				return;
			}
			state.priceGroup = { ...action.payload };
		}
	}
});

export const { setAddPriceGroupInput, setPriceGroup } = productSlice.actions;

export default productSlice.reducer;
